import { content } from '@content';

export const menuKey = {
  entryPackage: 'entry-package-file',
  smart: 'smart-file',
  module: 'module-file',
  template: 'template-file',
};

export const MENU_OPTIONS = [
  {
    id: menuKey.entryPackage,
    label: content.downloadEntirePackage,
  },
  {
    id: menuKey.smart,
    label: content.downloadSmartContentFile,
  },
  {
    id: menuKey.module,
    label: content.downloadModules,
  },
  {
    id: menuKey.template,
    label: content.downloadTemplate,
  },
];
